import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DownloadService } from '../../../core/services/download/download.service';
import { ClientDownload } from '../../../core/models/download/client-download.model';

@Component({
  selector: 'app-client',
  imports: [
    TranslateModule,
    CommonModule,
    RouterModule
  ],
  templateUrl: './download-client.component.html',
  styleUrl: './download-client.component.scss'
})
export class DownloadClientComponent implements OnInit {
  clientData: ClientDownload | null = null;
  loading: boolean = false;
  error: string | null = null;

  constructor(private readonly downloadService: DownloadService) {}

  ngOnInit(): void {
    this.loadLatestClient();
  }

  loadLatestClient(): void {
    this.loading = true;
    this.error = null;

    this.downloadService.getLatestClient()
      .subscribe({
        next: (data) => {
          this.clientData = data;
          this.loading = false;
        },
        error: (err) => {
          console.error('Error loading client data', err);
          this.error = 'Error loading client data. Please try again later.';
          this.loading = false;
        }
      });
  }

  /**
   * Gets the list of provider names from the clientData.files object
   * @returns An array of provider names
   */
  getProviders(): string[] {
    if (!this.clientData || !this.clientData.files) {
      return [];
    }
    return Object.keys(this.clientData.files);
  }
}
